import React, { useState, useEffect } from "react";
import { Container, Card, Form, Button, Image } from "react-bootstrap";
import { auth, db } from "../firebase"; // Importation correcte des modules Firebase v9+
import { getDoc, doc, updateDoc } from "firebase/firestore"; // Importation des fonctions nécessaires pour Firestore
import { updatePassword } from "firebase/auth"; // Importation pour la mise à jour du mot de passe
import { toast, ToastContainer } from "react-toastify"; // Import React-Toastify
import "react-toastify/dist/ReactToastify.css"; // Importation du style CSS de Toastify

function Profile() {
    const [profileData, setProfileData] = useState({
        name: "",
        email: "",
        phone: "",
    });

    const [profilePicture, setProfilePicture] = useState(null); 
    const [preview, setPreview] = useState(null); 
    const [newPassword, setNewPassword] = useState(""); // State for new password
    const [confirmPassword, setConfirmPassword] = useState(""); // State for password confirmation
    const [loading, setLoading] = useState(false); // Loading state to prevent multiple submissions


    // Fetch user information
    useEffect(() => {
        const fetchUserInfo = async () => {
            try {
                const user = auth.currentUser;
                if (user) {
                    const userRef = doc(db, "users", user.uid); 
                    const userDoc = await getDoc(userRef);

                    if (userDoc.exists()) {
                        const userData = userDoc.data();
                        setProfileData({
                            name: userData.name || "Nom non défini",
                            email: userData.email || "Email non défini",
                            phone: userData.phone || "Téléphone non défini",
                        });
                    } else {
                        toast.error("Aucun document utilisateur trouvé !");
                    }
                } else {
                    toast.error("Utilisateur non authentifié !");
                }
            } catch (error) {
                console.error("Erreur:", error);
                toast.error("Impossible de récupérer les informations utilisateur.");
            }
        };

        fetchUserInfo();
    }, []);

    const handleFileChange = (e) => {
        const file = e.target.files[0];

        if (file) {
            const validFileTypes = ["image/jpeg", "image/png", "image/jpg"];
            if (!validFileTypes.includes(file.type)) {
                toast.error("Veuillez sélectionner une image valide (JPEG ou PNG).");
                return;
            }

            setProfilePicture(file);

            // Create a preview of the image
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleProfileUpdate = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (newPassword && newPassword !== confirmPassword) {
            toast.error("Les mots de passe ne correspondent pas !");
            setLoading(false);
            return;
        }

        const user = auth.currentUser;
        if (user) {
            try {
                const docRef = doc(db, "users", user.uid);

                const updatedData = {
                    name: profileData.name,
                    email: profileData.email,
                    phone: profileData.phone,
                };

                if (preview) {
                    updatedData.profileImage = preview;
                }

                await updateDoc(docRef, updatedData);

                if (newPassword) {
                    await updatePassword(user, newPassword);
                }

                toast.success("Profil mis à jour avec succès !");
            } catch (error) {
                console.error("Erreur:", error);
                toast.error("Erreur lors de la mise à jour du profil.");
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <Container className="mt-4">
            <ToastContainer /> {/* Container for React-Toastify notifications */}
            <Card className="shadow-lg rounded">
                <Card.Body>
                    <Card.Title className="text-center">
                        Mon Profil
                    </Card.Title>

                    <Form onSubmit={handleProfileUpdate}>
                        <div className="d-flex justify-content-center mb-4">
                            {preview ? (
                                <Image
                                    src={preview}
                                    roundedCircle
                                    width="100"
                                    height="100"
                                />
                            ) : (
                                <div
                                    style={{
                                        width: "100px",
                                        height: "100px",
                                        borderRadius: "50%",
                                        backgroundColor: "#f0f0f0",
                                        border: "2px dashed #9caf7d",
                                    }}
                                >
                                    👤
                                </div>
                            )}
                        </div>
                        <Form.Group controlId="formFile" className="mb-3">
                            <Form.Label>Photo de Profil</Form.Label>
                            <Form.Control
                                type="file"
                                accept="image/*"
                                onChange={handleFileChange}
                            />
                        </Form.Group>

                        <Form.Group controlId="formName" className="mb-3">
                            <Form.Label>Nom</Form.Label>
                            <Form.Control
                                type="text"
                                value={profileData.name}
                                onChange={(e) =>
                                    setProfileData({ ...profileData, name: e.target.value })
                                }
                            />
                        </Form.Group>

                        <Form.Group controlId="formEmail" className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="email"
                                value={profileData.email}
                                readOnly
                            />
                        </Form.Group>

                        <Form.Group controlId="formPhone" className="mb-3">
                            <Form.Label>Téléphone</Form.Label>
                            <Form.Control
                                type="tel"
                                value={profileData.phone}
                                onChange={(e) =>
                                    setProfileData({ ...profileData, phone: e.target.value })
                                }
                            />
                        </Form.Group>

                        <Form.Group controlId="formNewPassword" className="mb-3">
                            <Form.Label>Mot de Passe</Form.Label>
                            <Form.Control
                                type="password"
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                placeholder="Nouveau mot de passe"
                            />
                        </Form.Group>

                        <Form.Group controlId="formConfirmPassword" className="mb-3">
                            <Form.Label>Confirmer le Mot de Passe</Form.Label>
                            <Form.Control
                                type="password"
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                placeholder="Confirmer le mot de passe"
                            />
                        </Form.Group>

                        <Button
                            variant="primary"
                            type="submit"
                            disabled={loading}
                            className="w-100"
                        >
                            {loading ? "Mise à jour..." : "Mettre à jour"}
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        </Container>
    );
}

export default Profile;
